import { Navigate, useParams } from 'react-router-dom';

const ZeeProfile = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to="/dashboard/data-center?tab=discovery" replace />;
  }

  return <Navigate to={`/dashboard/lead-profile/${id}`} replace />;
};

export default ZeeProfile;
